import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Clock, LogIn } from 'lucide-react'
import { useUiStore } from '../store/uiStore'

/**
 * Přátelská obrazovka po odhlášení (neaktivita / vypršení relace).
 * Překryje celou stránku; tlačítko otevře přihlašovací modal.
 */
export default function SessionEndedScreen() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { sessionEnded, clearSession, openAuthModal } = useUiStore()

  if (!sessionEnded) return null

  const title = sessionEnded === 'idle'
    ? t('auth.session_idle_title', { defaultValue: 'Byli jste odhlášeni' })
    : t('auth.session_expired_title', { defaultValue: 'Relace vypršela' })
  const desc = sessionEnded === 'idle'
    ? t('auth.session_idle_desc', { defaultValue: 'Z důvodu dlouhé neaktivity jsme vás pro vaši bezpečnost odhlásili.' })
    : t('auth.session_expired_desc', { defaultValue: 'Vaše přihlášení vypršelo. Přihlaste se prosím znovu.' })

  const relogin = () => {
    clearSession()
    navigate('/', { replace: true })
    openAuthModal('login')
  }

  return (
    <div className="fixed inset-0 z-[300] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" />
      <div className="relative w-full max-w-sm glass-dark border border-white/10 rounded-2xl shadow-2xl p-8 text-center animate-fade-in">
        <div className="w-14 h-14 mx-auto mb-5 rounded-2xl bg-gradient-to-br from-primary-500 to-accent-500 flex items-center justify-center shadow-lg shadow-primary-500/25">
          <Clock className="w-7 h-7 text-white" />
        </div>
        <h2 className="text-xl font-bold text-white mb-2">{title}</h2>
        <p className="text-gray-400 text-sm mb-7">{desc}</p>
        <button
          onClick={relogin}
          className="w-full bg-gradient-to-r from-primary-600 to-primary-500 text-white py-3 rounded-lg font-semibold hover:shadow-lg hover:shadow-primary-500/25 transition-all flex items-center justify-center gap-2 text-sm cursor-pointer"
        >
          <LogIn className="w-4 h-4" />
          {t('auth.session_relogin', { defaultValue: 'Přihlásit se znovu' })}
        </button>
      </div>
    </div>
  )
}
